import { MerchantPlanTypes } from '@frontend/api-payments';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { PaymentMethodButtons } from './buttons';

export const PaymentMethodsButtonsJustifi = () => {
  const {
    justifiData: { enableShareInEmail },
    merchant,
    isDemoLocation,
  } = useCollectPaymentMultiContext();

  const shouldShowTerminal =
    (!!merchant?.planName &&
      (merchant?.planName === MerchantPlanTypes.FullPayments || merchant?.planName === MerchantPlanTypes.Full)) ||
    isDemoLocation;

  return (
    <>
      <PaymentMethodButtons.ShareInMessage />

      {enableShareInEmail && <PaymentMethodButtons.ShareInEmail />}

      {shouldShowTerminal && <PaymentMethodButtons.SelectTerminal />}

      <PaymentMethodButtons.CardOnFile enableACHOnFile={false} />

      <PaymentMethodButtons.ManualCardEntry />
    </>
  );
};
